import Button from "@restart/ui/esm/Button";
import React, { createRef, useCallback, useEffect, useState } from "react";
import Div100vh, { use100vh } from "react-div-100vh";
import { createUseStyles } from "react-jss";
import { useAuth, useLocalStorage } from "../../core";
import { WidgetAuthentication } from "./WidgeAuthentication";
import { WidgetBotContainer } from "./WidgetBotContainer";
import ARTIN from "../../assets/images/bot.svg";
import useStylesChatContainer from "../atoms/chatContainerStyle";
import { StringParam, useQueryParam } from "use-query-params";
import { LoadingPage } from "../pages/LoadingPage";
import InvalidTokenWidget from "../pages/InvalidTokenWidget";

const useStyles = createUseStyles((theme) => ({
  chatButton: {
    position: "absolute",
    right: 0,
    bottom: 0,
    background: theme.headerBg,
    color: "white",
    height: 60,
    width: 60,
    borderRadius: "50%",
    border: "none",
    "&:hover": {
      opacity: 0.8,
    },
  },
  chatbox: {
    position: "fixed",
    height: 750,
    width: 550,
    right: 10,
    bottom: 10,
    "& #helpButton": {
      right: "30px!important",
    },
    "& #jumpButton": {
      right: "30px!important",
    },
    "& #powerBy": {
      width: "calc(100% - 27px)",
    },
  },

  // "@media screen and (min-width: 800px) ": {
  //   "& .rsc-content": {
  //     height: 500,
  //   },
  // },

  "@media screen and (max-width: 799px) ": {
    chatbox: {
      position: "absolute",
      height: "100%",
      width: "100%",
      right: 0,
      bottom: 0,
      "& #helpButton": {
        right: "20px!important",
      },
      "& #jumpButton": {
        right: "30px!important",
      },
    },
  },
}));

const ChatWidget = () => {
  // const [showChat, setShowChat] = useState(false);
  const [showChat, setShowChat] = useLocalStorage("showChat", false);
  const chatboxRef = createRef(null);
  const height = use100vh();
  const styles = useStyles({ height });
  const stylesContainer = useStylesChatContainer({ height });
  const [urlToken] = useQueryParam("token", StringParam);
  const { user, tokenLogin, loadingToken } = useAuth();
  useEffect(() => {
    if (urlToken) {
      try {
        tokenLogin(urlToken);
      } catch (error) {}
    }
  }, [urlToken]);
  useEffect(() => {
    window.parent.postMessage(
      {
        func: "parentFunc",
        message: showChat,
      },
      "*"
    );
  }, [showChat]);
  const getTokenBasedComponent = useCallback(() => {
    if (!urlToken) {
      return <InvalidTokenWidget {...{ showChat, setShowChat }} />;
    }
    if (loadingToken && !user) {
      return <LoadingPage />;
    } else {
      if (user?.loggedIn) {
        return <WidgetBotContainer {...{ showChat, setShowChat }} />;
      }
      // else {
      //   return <InvalidToken />;
      // }
    }
  }, [user]);
  return (
    <>
      {showChat ? (
        <Div100vh className={stylesContainer.container}>
          <div className={styles.chatbox} ref={chatboxRef}>
            {!urlToken ? (
              user?.loggedIn || process.env.REACT_APP_LOGIN === "false" ? (
                <WidgetBotContainer {...{ showChat, setShowChat }} />
              ) : process.env.REACT_APP_ONLY_URL_TOKEN === "false" ? (
                <WidgetAuthentication {...{ showChat, setShowChat }} />
              ) : (
                <InvalidTokenWidget {...{ showChat, setShowChat }} />
              )
            ) : (
              // <Authentication />
              getTokenBasedComponent()
            )}
          </div>
        </Div100vh>
      ) : (
        <Div100vh
          style={{ position: "fixed", zIndex: 2000, right: 5, bottom: 5 }}
        >
          <Button
            onClick={() => setShowChat(true)}
            className={styles.chatButton}
          >
            <img src={ARTIN} alt="bot" srcSet="" width={32} />
          </Button>
        </Div100vh>
      )}
    </>
  );
};

export { ChatWidget };
